// 
export const generateRowData = (dataRow, columns) => {
    const cells = [];
    let index = 0;
    columns.forEach(col => {
        
        if (col.subColumns) {
            col.subColumns.forEach(sub => { cells.push(dataRow?.[ sub.key ] ?? "-"); index++; });
        } else {
            
            cells.push(dataRow?.[ col.label ] ?? "-");
            index++;
        }

    });

    return cells;
};

// get total widths of all columns including sub-columns
export const getColumnWidths = (columns) =>
    columns.flatMap(col => col.subColumns?.map(sub => sub.width) || [ col.width ]);
